export const colors = {
  // Status Colors
  success: '#81c784',
  error: '#e57373',
  pending: '#4CA7E4',
  warning: '#ff9800',
  
  // Semantic Aliases
  failed: '#e57373', // Use same color as error for consistency
  
  // File Type Colors
  pdf: '#f44336',    // Red
  document: '#2196f3', // Blue
  spreadsheet: '#4caf50', // Green
  code: '#ff9800',   // Orange
  text: '#9e9e9e',   // Gray
  file: '#4CA7E4',   // Default blue (same as pending)
} as const;

export type ColorKey = keyof typeof colors;
